import ItemListView from "../../../components/ItemListView/ItemListView.vue";
import ItemView from "../../../components/ItemView/ItemView.vue";
import { addSafetyObjectiveRegisterForm } from "./actions.js";
import attachables from "./attachables.js";

export default [{
    "path": "/SafetyManagement/SafetyObjectiveRegister",
    "component": { ...ItemListView },
    "name": "Safety Objective Register",
    "meta": {
        "app": "SafetyManagement",
        "sideNav": true,
        "appSwitcher": false,
        "sideNavSection": "Safety and Risk Management",
        "name": "Safety Objective Register",
        "tableSettings": "RiskRegister",
        "dataPath": "SafetyManagement/SafetyObjectiveRegister",
        "selectionRoute": "SafetyManagement/SafetyObjectiveRegister/{ID}",
        "menuActions": [{
            "label": "Add Safety Objective Register Form",
            "action": addSafetyObjectiveRegisterForm
        }]
    }
}, {
    "path": "/SafetyManagement/SafetyObjectiveRegister/:id",
    "component": ItemView,
    "name": "Safety Objective Register Entry",
    "meta": {
        "app": "SafetyManagement",
        "name": "Safety Objective Register Entry",
        "dataPath": "SafetyManagement/SafetyObjectiveRegister",
        "storeData": ["Database/DocumentTypes", "SafetyManagement/Categories"],
        "title": (item) => `Safety Objective Register: ${item.Number}`,
        "dataFields": [{
            "label": "Number",
            "key": "Number"
        }, {
            "label": "Title",
            "key": "Title",
            "class": "md:col-span-2"
        }, {
            "label": "Latest Revision",
            "key": "Revision",
            "type": "text",
            "actionButton": true,
            "actionText": "Download",
            async action({ pageItem, db }) {
                let url = await db.download(`Database/SafetyObjectiveRegister/${pageItem.ID}/Revisions/${pageItem.RevisionID}/${pageItem.Revisions[pageItem.RevisionID].File}`);
                window.open(url, "fileView", "popup");
            }
        }],
        "menuActions": [],
        "attachedItems": {
            "Details": {
                "attachables": attachables
            }
        }
    }
}];
